'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var Misc = require('utils/misc');
var i18n = require('utils/i18n');

function updateLabelKey(prefix, key) {
    key = '' + key;
    var isExcluded = false;
    if (key.startsWith('_-_')) {
        isExcluded = true;
        key = key.substr(3);
    }
    return '' + (isExcluded ? '_-_' : '') + prefix + key;
}

function getStatusBits(inputData) {
    var statusBits = Misc.selectWhere(
        _.keys(Consts.CategoryData),
        function (ck) {
            var myCategory = Consts.CategoryData[ck].category;
            // no category at all selected
            if (!inputData || !inputData.category || !inputData.category.length) return true;
            // category selected
            if (
                Misc.countWhere(inputData.category, function (x) {
                    return x == myCategory;
                }) > 0
            ) {
                return true;
            }
            // category present in a filter condition
            if (!inputData.conditions || !inputData.conditions.length) return false;

            return (
                Misc.countWhere(inputData.conditions, function (x) {
                    return x.value && x.value.indexOf('@' + myCategory) > 0;
                }) > 0
            );
        },
        function (ck) {
            var cat = Consts.CategoryData[ck];
            return {
                categoryName: cat.name,
                bits: Misc.selectWhere(
                    _.keys(cat.statusErrors.codes),
                    function (r) {
                        return cat.statusErrors.codes[r] > 0;
                    },
                    function (r) {
                        return {
                            text: cat.statusErrors.messages[r],
                            value: cat.statusErrors.codes[r] + '@' + cat.category,
                        };
                    }
                ),
            };
        }
    );
    statusBits = _.sortBy(statusBits, function (a) {
        return a.categoryName;
    });
    return statusBits;
}

function isFieldValid(item) {
    if (
        Misc.countWhere(Consts.FieldInfo.NoFilter, function (x) {
            return x == item.id;
        })
    ) {
        return false;
    }

    return item.unit != 'Uhr' && item.format != 't##.##.';
}

function updateEmptySelectValue(value, isFromSelect) {
    if (Array.isArray(value)) {
        _.each(value, function (item, index) {
            if (isFromSelect === true) {
                if (item === '__empty__') {
                    value[index] = '';
                }
            } else {
                if (item === '') {
                    value[index] = '__empty__';
                }
            }
        });
    }
    return value;
}

function isOpMultiSelect(c) {
    return c.op == 'ANY' || c.op == 'NONEOF';
}

var DeviceFilterView = Backbone.Marionette.ItemView.extend({
    template: require('components/devices/templates/common/device_filter'),
    backgroundTasks: Misc.getBackgroundTaskManager(),
    lastFilterStr: undefined,
    onLoadComplete: undefined,
    errors: {},

    ui: {
        ddlCategories: 'select#df-categories',
        ddlGroups: 'select#df-groups',
        ddlLabels: 'select#df-labels',
        ddlStatus: 'select#df-status',
        pnlConditions: 'div#df-conditions',
        edtSearchText: 'input#df-search-text',

        btnCondAdd: 'button#df-cond-add',
        btnCondDelete: 'button.js-df-cond-delete',
        ddlField: 'select.js-df-field',
        ddlValueType: 'select.js-df-field2-type',
    },

    events: {
        'click @ui.btnCondAdd': 'onCondAdd',
        'click @ui.btnCondDelete': 'onCondDelete',
        'click .js-df-search': 'forceUpdate',
        'change @ui.ddlField': 'onFieldChanged',
        'change @ui.ddlValueType': 'triggerUpdate',
        'change select.js-filter-select': 'triggerNoRender',
        'change select.js-value-status': 'triggerNoRender',
        'change select.js-df-op': 'triggerUpdate',
        'hide.bs.dropdown .js-value-status': 'triggerUpdate',
        'keyup input.js-datepicker': 'onFilterEditKey',
        'keyup input.js-filter-edit': 'onFilterEditKey',
        'changeDate .input-group.date': 'triggerUpdate',
        'blur .js-timepicker': 'triggerUpdate',
        'blur input.js-filter-edit': 'triggerUpdate',
        'keyup .js-timepicker': 'onFilterEditKey',
        'hide.timepicker .js-timepicker': 'triggerUpdate',
        'hide.bs.select select.js-filter-multiselect': 'triggerUpdate',
        'hide.bs.select select.js-filter-select': 'triggerUpdate',
    },

    basicData: {},

    inputData: {},

    colData: {},

    initialize: function (options) {
        var self = this;
        this.lastFilterStr = '{}';
        this.inputData = { conditions: [] };
        this.onFilterChanged = options.onFilterChanged;
        this.onLoadComplete = options.onLoadComplete;
        this.onChangeSelectDevices = options.onChangeSelectDevices;
        this.onValidateFilter = options.onValidateFilter;
        this.showDeviceCount = options.showDeviceCount;
        this.cache = options.cache;
        this.noGroups = options.noGroups;
        this.showResults = options.showResults;
        if (this.cache) {
            this.initializeCache();
        }

        this.loadBasicData();
        this.inputData = $.extend(true, {}, options.defaultFilter);
        _.each(this.inputData.device_groups, function (g, idx) {
            self.inputData.device_groups[idx] = '' + g;
        });
        _.each(this.inputData.device_groups_excluded, function (eg) {
            self.inputData.device_groups = self.inputData.device_groups || [];
            self.inputData.device_groups.push('_-_' + eg);
        });
        _.each(this.inputData.conditions, function (c, _) {
            if (isOpMultiSelect(c)) {
                // convert string to an array
                c.value = JSON.parse(c.value);
            }
        });

        this.backgroundTasks.done(function () {
            this.loadFieldContentData();
            // Initializiation completely finished
            this.backgroundTasks.done(function () {
                if (this.onLoadComplete) {
                    setTimeout(function () {
                        self.onLoadComplete();
                        if (self.showResults) {
                            self.forceUpdate();
                            return;
                        }
                        if (JSON.stringify(self.getFilter()) != '{}') {
                            self.backgroundTasks.done(function () {
                                self.handleFilterChange();
                            });
                        }
                    });
                }
            }, this);
        }, this);
    },

    splitDeviceGroups: function (obj) {
        var excludedGroups = [];
        var includedGroups = [];
        _.each(obj.device_groups, function (grp) {
            if (grp.startsWith('_-_')) {
                excludedGroups.push(parseInt(grp.substr(3)));
            } else {
                includedGroups.push(parseInt(grp));
            }
        });

        if (obj.device_groups) {
            obj.device_groups = includedGroups;
            obj.device_groups_excluded = excludedGroups;
        }
    },

    getFilter: function () {
        var obj = {};
        var inputData = this.inputData;
        _.each(['tags', 'groups', 'status', 'category', 'search_text', 'device_groups'], function (key) {
            if (inputData[key]) obj[key] = inputData[key];
        });

        // split device groups into include groups and exclude groups
        this.splitDeviceGroups(obj);

        if (inputData.conditions && inputData.conditions.length) {
            obj.conditions = [];
            _.each(inputData.conditions, function (cond, idx) {
                obj.conditions[idx] = _.clone(cond);
                if (Array.isArray(obj.conditions[idx].value)) {
                    obj.conditions[idx].value = JSON.stringify(obj.conditions[idx].value);
                }
            });
        }

        return obj;
    },

    triggerNoRender: function (e) {
        this.updateInputData();
    },

    triggerUpdate: function (e) {
        this.updateInputData();
        this.render();
        this.handleFilterChange();
    },

    onFilterEditKey: function (e) {
        if (e.keyCode == 13) {
            this.triggerUpdate();
        }
    },

    getRowIdx: function (event) {
        return parseInt($(event.currentTarget).closest('.js-df-cond-row').attr('data-row'));
    },

    initializeCache: function () {
        if (!this.cache.keys) {
            this.cache.keys = ['tags', 'groups', 'fieldSet', 'deviceGroups'];
        }
    },

    loadFieldContentData: function () {
        var self = this;
        var usedFields = Misc.selectWhere(this.inputData.conditions, undefined, 'field');
        var fields = Misc.selectWhere(
            this.getFields(),
            function (item) {
                return (
                    usedFields.indexOf(item.id) >= 0 &&
                    !self.colData[item.id] &&
                    Consts.FieldInfo.Date.indexOf(item.id) < 0 &&
                    Consts.FieldInfo.Numeric.indexOf(item.id) < 0
                );
            },
            'id'
        );
        var reqs = Misc.selectWhere(fields, undefined, function (item) {
            return App.request('values:content', item);
        });
        this.backgroundTasks.whenArray(reqs).done(function () {
            _.each(arguments, function (data, idx) {
                self.colData[fields[idx]] = data;
            });
        });
    },

    loadBasicData: function () {
        var self = this;

        // attempt to get the data from the cache
        if (this.cache && this.cache.hasContent) {
            _.each(this.cache.keys, function (key) {
                self.basicData[key] = self.cache[key];
            });
            return;
        }

        var labelsReq = App.request('filter:labels', { complete: true });
        var deviceGroupsReq = App.request('groups:list', Consts.GroupReqMode.Filter);
        this.backgroundTasks.add(labelsReq, deviceGroupsReq);
        $.when(labelsReq, deviceGroupsReq).done(function (labelsData, deviceGroups) {
            self.basicData = {
                tags: labelsData.tags || [],
                groups: labelsData.groups || [],
                deviceGroups: deviceGroups.toJSON(),
                fieldSet: [
                    {
                        name: i18n.TR('Geräte Eigenschaften'),
                        items: self.getFields(Consts.FieldGroup.Device),
                    },
                    {
                        name: i18n.TR('Daten'),
                        items: self.getFields(Consts.FieldGroup.Data),
                    },
                    {
                        name: i18n.TR('Verwaltung'),
                        items: self.getFields(Consts.FieldGroup.Meta),
                    },
                ],
            };

            if (self.cache) {
                _.each(self.cache.keys, function (key) {
                    self.cache[key] = self.basicData[key];
                });
                self.cache.hasContent = true;
            }
        });
    },

    getFields: function (fieldGroup) {
        // get all fields
        var fields = Misc.selectWhere(AppState.uniqueFields(undefined, fieldGroup), function (item) {
            return isFieldValid(item);
        });

        // translate names
        _.each(fields, function (e) {
            e.name = i18n.DATAPOINT((e.categories || [''])[0], e.name);
        });

        // return sorted list
        return _.sortBy(fields, function (e) {
            return e.name;
        });
    },

    forEachCategories: function (fct) {
        return Misc.selectWhere(
            _.pairs(Consts.CategoryData),
            function (item) {
                return item[1].inVirtualDevice !== false;
            },
            function (item) {
                return fct(item[1]);
            }
        );
    },

    getField: function (fieldKey) {
        if (fieldKey.substr(0, 2) == '#_') return fieldKey.substr(2, fieldKey.length - 2);
        return fieldKey;
    },

    serializeData: function () {
        // cleanup: all rows without a field
        this.inputData.conditions = Misc.selectWhere(this.inputData.conditions, function (item) {
            return item.field;
        });

        var self = this;
        var data = {};

        data.categories = _.sortBy(
            Misc.selectWhere(
                _.pairs(Consts.CategoryData),
                function (item) {
                    return item[1].inVirtualDevice !== false && (AppState.user.get('is_admin') || !item[1].adminOnly);
                },
                function (item) {
                    return {
                        name: item[1].name,
                        value: item[1].category,
                        icon: item[1].icon,
                    };
                }
            ),
            'name'
        );

        data.errors = this.errors;
        data.tags = this.basicData.tags;
        data.groups = this.noGroups ? undefined : this.basicData.groups;
        data.fieldSet = this.basicData.fieldSet;
        data.deviceGroups = this.basicData.deviceGroups;
        data.statusBits = getStatusBits(this.inputData);
        data.showDeviceCount = this.showDeviceCount && this.deviceCount !== undefined;
        data.deviceCount = this.deviceCount;
        data.dataCols = self.getFields(Consts.FieldGroup.Data);
        data.fixedStatus = this.options.fixedStatus;
        data.fixedCategory = this.options.fixedCategory;

        data.inputData = _.clone(this.inputData);
        data.inputData.labels = _.flatten([
            Misc.selectWhere(this.inputData.groups, undefined, function (item) {
                return updateLabelKey('g_', item);
            }),
            Misc.selectWhere(this.inputData.tags, undefined, function (item) {
                return updateLabelKey('t_', item);
            }),
        ]);
        data.inputData.groups = _.flatten([
            Misc.selectWhere(this.inputData.groups, undefined, function (item) {
                return 's_' + item;
            }),
            Misc.selectWhere(this.inputData.device_groups, undefined, function (item) {
                return updateLabelKey('d_', item);
            }),
        ]);
        data.inputData.conditions = [];
        // conditions must be cloned as well
        _.each(this.inputData.conditions, function (cond, idx) {
            data.inputData.conditions[idx] = {
                field: cond.field,
                op: cond.op,
                value: _.clone(cond.value),
            };
            updateEmptySelectValue(data.inputData.conditions[idx].value);
        });

        _.each(data.inputData.conditions, function (cond, idx) {
            self.addRenderData(cond, idx);
        });

        return data;
    },

    addRenderData: function (cond, idx) {
        cond.row = idx;

        cond.useMultiSelect = isOpMultiSelect(cond);

        var fieldInfo = AppState.availableColumnData(cond.field) || {
            field_type:
                cond.field.split('_').length == 2 && parseInt(cond.field.split('_')[1]) > 0
                    ? Consts.FieldGroup.Data
                    : undefined,
        };

        // is for the drop down
        cond.isFixedTextSelect = this.colData[cond.field] && this.colData[cond.field].length > 0;
        cond.comparison = Misc.selectWhere(Consts.Backend.Comparison, function (item) {
            if (cond.isFixedTextSelect) {
                if (item.for_status == true && item.k != 'ALL') {
                    return true;
                }
            }
            return item.for_status == (cond.field == 'status');
        });
        cond.isFieldData = fieldInfo.field_type == Consts.FieldGroup.Data;
        cond.isFixedDate = Consts.FieldInfo.Date.indexOf(cond.field) != -1;
        cond.isFixedText = !cond.isFieldData && !cond.isFixedDate;
        cond.isFixedNumeric = Consts.FieldInfo.Numeric.indexOf(cond.field) != -1;
        cond.fieldTextSelectOptions = this.colData[cond.field];
        cond.isFieldStatus = cond.field == 'status';
        cond.isFixedText = cond.isFixedText && !cond.isFieldStatus;

        if (cond.isFieldStatus) {
            cond.value = (cond.value || '').split(',');
        }

        if (cond.isFieldData) {
            var fieldValueInfo = AppState.availableColumnData(cond.value) || {};
            cond.isFieldDataRef = fieldValueInfo.field_type == Consts.FieldGroup.Data;
            cond.isFieldDataTypeEnum = false;
            cond.fieldDataEnumItems = undefined;

            if (!cond.isFieldDataRef) {
                var valueSpecs = AppState.availableColumnData(cond.field) || {};
                if (valueSpecs.format)
                    cond.isFieldDataTypeEnum =
                        valueSpecs.format.substr(0, 2) == 'r{' || valueSpecs.format.indexOf('/') > 0;
                if (cond.isFieldDataTypeEnum) cond.fieldDataEnumItems = Misc.getEnumItems(valueSpecs.format);
                else {
                    var valueUnit = Misc.formatValueUnit(
                        parseFloat(cond.value || 0),
                        cond.field,
                        AppState.uniqueColumns(),
                        true
                    );
                    cond.value = valueUnit.value;
                    cond.valueUnit = valueUnit.unit;
                }
            }
        }

        if (cond.isFixedDate) {
            var m = moment.utc(cond.value, 'DD.MM.YYYY HH:mm');
            if (!m.isValid()) {
                m = moment();
            }
            cond.valueDate = m.local().format('DD.MM.YYYY');
            cond.valueTime = m.local().format('HH:mm');
        }
    },

    onShow: function () {
        var self = this;
        this.initControls();
        setTimeout(function () {
            self.handleFilterChange(true);
        });
        Misc.equalizeHeight($('.js-same-height'));
    },

    onRender: function () {
        this.initControls();
    },

    initControls: function () {
        Misc.initSelectPicker();
        Misc.initTimePicker(this.getOption('container'));
        Misc.initDatePicker();
    },

    updateInputData: function () {
        var self = this;
        var filterGroups = function (type, toInt, src) {
            var result = Misc.selectWhere(
                src || self.ui.ddlGroups.val(),
                function (item) {
                    if (item.startsWith('_-_')) {
                        item = item.substr(3);
                    }
                    return item.substr(0, 2) == type;
                },
                function (item) {
                    var isExcluded = false;
                    if (item && item.length > 0 && item.startsWith('_-_')) {
                        item = item.substr(3);
                        isExcluded = true;
                    }
                    var value = item.substr(2, item.length);
                    return '' + (isExcluded ? '_-_' : '') + (toInt ? parseInt(value) : value);
                }
            );
            return result.length > 0 ? result : undefined;
        };

        this.inputData.category = this.ui.ddlCategories.val();
        this.inputData.groups = filterGroups('g_', false, Misc.getValue3State(this.ui.ddlLabels));
        this.inputData.tags = filterGroups('t_', false, Misc.getValue3State(this.ui.ddlLabels));
        this.inputData.device_groups = filterGroups('d_', false, Misc.getValue3State(this.ui.ddlGroups));

        this.inputData.status = this.ui.ddlStatus.val();
        this.inputData.search_text = this.ui.edtSearchText.val().trim();

        var self = this;
        _.each(this.inputData.conditions, function (cond, condIdx) {
            var $row = $(self.ui.pnlConditions.find('div.js-df-cond-row[data-row="' + condIdx + '"]'));

            cond.field = $row.find('select.js-df-field').val();
            cond.op = $row.find('select.js-df-op').val();

            var dummyRow = _.clone(cond);
            dummyRow.field = dummyRow.field || '';
            dummyRow.value = dummyRow.value || '';
            self.addRenderData(dummyRow);

            if (dummyRow.isFixedText) {
                cond.value = $row.find('input.js-df-field-text-fixed').val();
            }

            if (dummyRow.isFixedTextSelect) {
                cond.value = Misc.getValue3State($row.find('select.js-df-field-text-select'));
                cond.value = updateEmptySelectValue(cond.value, true);
            }

            if (dummyRow.isFixedNumeric) {
                cond.value = parseInt(cond.value);

                if (isNaN(cond.value)) cond.value = 0;
            }

            if (dummyRow.isFixedDate) {
                var date = $row.find('.js-df-value-date').val();
                var time = $row.find('.js-df-value-time').val();

                var d = moment(date + ' ' + time, 'DD.MM.YYYY HH:mm').utc();
                if (!d.isValid()) {
                    d = moment();
                }
                cond.value = d.format('DD.MM.YYYY HH:mm');
            }

            dummyRow.isFieldDataRef = $row.find('select.js-df-field2-type').val() == 'v';
            if (dummyRow.isFieldDataRef) {
                cond.value = $row.find('select.js-df-field2').val();
                if (!cond.value) {
                    var cols = AppState.availableColumns();
                    if (cols.length > 0) cond.value = cols[0].id;
                }
            } else {
                if (dummyRow.isFieldData) {
                    if (dummyRow.isFieldDataTypeEnum) {
                        cond.value = $row.find('select.js-df-field2-enum').val();
                    } else {
                        var valueSpec = AppState.availableColumnData(cond.field);
                        var v = parseFloat($row.find('input.js-df-field2-fixed').val());
                        if (isNaN(v)) {
                            v = 0;
                        }

                        if (valueSpec) {
                            cond.value = Misc.getRawValue(v, valueSpec.id.substr(0, 3), valueSpec.format);
                        } else {
                            cond.value = v;
                        }
                    }
                }
            }

            if (dummyRow.isFieldStatus) {
                cond.value = ($row.find('select.js-value-status').val() || []).join(',');
            }

            if (!Array.isArray(cond.value)) {
                if (cond.value === null) {
                    cond.value = '';
                }
                cond.value = '' + cond.value || '';

                if (cond.field != 'status' && isOpMultiSelect(cond)) {
                    cond.value = cond.value ? [cond.value] : [];
                }
            }
        });
    },

    onCondAdd: function () {
        this.updateInputData();
        if (!this.inputData.conditions) {
            this.inputData.conditions = [];
        }

        // get the first column
        var cols = AppState.availableFields();
        var col = Misc.selectWhereFirst(
            _.sortBy(cols, function (item) {
                return item.name;
            }),
            function (item) {
                return isFieldValid(item);
            },
            'id'
        );
        this.inputData.conditions.push({ field: col });
        this.render();
        this.updateInputData();
        this.render();
        this.handleFilterChange();
    },

    onCondDelete: function (e) {
        var idx = this.getRowIdx(e);
        this.updateInputData();
        this.inputData.conditions.splice(idx, 1);
        this.render();
        this.handleFilterChange();
    },

    onFieldChanged: function (e) {
        var self = this;
        var idx = this.getRowIdx(e);
        var row = this.inputData.conditions[idx];
        var newField = $(this.ui.pnlConditions.find('div.js-df-cond-row[data-row="' + idx + '"]'))
            .find('select.js-df-field')
            .val();
        if (newField == row.field) return;

        row.field = newField;
        row.value = undefined;
        AppState.Cache.require({ columns: true }, function () {
            self.loadFieldContentData();
            self.backgroundTasks.done(function () {
                self.render();
                self.updateInputData();
                self.handleFilterChange();
            });
        });
    },

    setDeviceCount: function (deviceCount) {
        this.deviceCount = deviceCount;
        this.render();
    },

    forceUpdate: function (e) {
        this.updateInputData();
        var URLInfos = this.inputData;
        if (e === undefined) {
            URLInfos = $.extend(URLInfos, this.options.controller.getRequestParams());
        }
        AppState.setURLParameter(URLInfos, 'replace');
        this.lastFilterStr = 'forceUpdate';
        this.handleFilterChange(e === undefined);
    },

    isValid: function () {
        return this.onValidateFilter ? this.onValidateFilter(this) : true;
    },

    handleFilterChange: function (isReload) {
        var newFilter = this.getFilter();
        var json = JSON.stringify(newFilter);
        if (this.lastFilterStr !== json) {
            this.lastFilterStr = json;
            if (this.onFilterChanged) {
                this.onFilterChanged(newFilter, isReload);
            }
            if (this.onValidateFilter) {
                this.errors = {};
                if (!this.onValidateFilter(this)) {
                    this.render();
                }
            }
        }
    },
});

module.exports = DeviceFilterView;
